import React from "react";

export default function DashboardCard({ title, subtitle, action, children, className = "" }) {
  return (
    <section className={`dash-card h-100 ${className}`.trim()}>
      {(title || subtitle || action) && (
        <header className="dash-card__header">
          <div>
            {subtitle ? <div className="dash-card__eyebrow">{subtitle}</div> : null}
            {title ? <h2 className="dash-card__title mb-0">{title}</h2> : null}
          </div>
          {action ? <div className="dash-card__action">{action}</div> : null}
        </header>
      )}
      <div className="dash-card__body">{children}</div>
    </section>
  );
}
